import React from 'react';
import Button from '../../../CoreWrappers/Button';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

const AddElementButton = (props) => {
	const propsBtn = {
		svg: IconoirPlusCircle,
		iconSize: 20,
		variant: 'text-alt',
		label: props.label,
		onClick: () => props.onClick(),
		disabled: props.disabled || false
	};
	return <Button {...propsBtn} />;
};

export default AddElementButton;
